import { environment } from '../../../environments/environment';

export const API_ENDPOINTS = {
  DASHBOARD: {
    GET_REPORT: `${environment.api.baseUri}api/Report/Get`,
    GET_ALL_REPORTS: `${environment.api.baseUri}api/Report/GetReportAsync`,
    INSERT_USER_REPORT_SELECTION: `${environment.api.baseUri}api/Report/InsertUpdateReportAsync`,
    /* GET_REPORT: `${environment.api.baseUri}/FADashboard/GetNexGenReportDetails`,*/
    FILTER_PEERS: `${environment.api.baseUri}/Dashboard/GetNexgenSearchAndFilteredPeers`,
    GET_ACCESS_TOKEN: `${environment.api.baseUri}/Dashboard/GetDUAAccessToken`,
    
    GET_DASBOARD_ACCESS: `${environment.api.baseUri}api/Report/GetDashboardAccessByEmailAndReportId`,
    /*GET_DASBOARD_ACCESS: `${environment.api.baseUri}/Dashboard/GetDashboardAccessByEmailAndReportId`,*/
    GET_REPORT_TOKEN : `${environment.api.baseUri}api/auth/GetReportTokenAsync`
  },
  POWERBI: {
    TOKEN_URL: 'https://api.powerbi.com/v1.0/myorg/GenerateToken',
    EMBED_REPORT_URL: 'https://app.powerbi.com/reportEmbed'
  },
  APQC: {
    GET_SYSTEM_CONFIGVALUES_BYNAME: `${environment.api.baseUri}/Dashboard/GetSystemConfigValuesByName`,
    GET_PPT_REPORT: `${environment.api.baseUri}/Dashboard/ExportApqcReport`,
    GET_METRIC_IDS_BY_METRICNAMES: `${environment.api.baseUri}/Dashboard/GetMetricIdsByMetricNames`,
    GET_METRIC_NAMES_BY_METRICIDS: `${environment.api.baseUri}/Dashboard/GetMetricNamesByMetricIds`,
    SAVE_EXCEL_REPORT_DATA: `${environment.api.baseUri}/Dashboard/GetAPQCDataForExcel`,
    GET_EXCEL_REPORT: `${environment.api.baseUri}/Dashboard/GetAPQCReport`
  },
  FMANALYSIS: {
    GET_CURRENCY_LIST: `${environment.api.baseUri}/FADashboard/getCurrencies`,
    GET_COMPANIES_LIST: `${environment.api.baseUri}/FADashboard/GetCompanyCountByStudy`,
    GET_INDUSTRIES_LIST: `${environment.api.baseUri}/FADashboard/getIndustries`,
    GET_FISCAL_YEAR_LIST: `${environment.api.baseUri}/Dashboard/GetNexgenFiscalPeriodDropDown`,
    GET_PARTNER_LIST: `${environment.api.baseUri}/Study/GetAllPartners`,
    GET_REGIONS_LIST: `${environment.api.baseUri}/FADashboard/getRegions`,
    GET_PEER_LIST: `${environment.api.baseUri}/FADashboard/getPeerTypes`,
    // GET_TARGET_COMPANY: `${environment.api.baseUri}/Dashboard/GetTargetCompanyDetailByCompanyId`,
    GET_ALL_COMPANIES:`${environment.api.baseUri}/FADashboard/getAllCompanies`,
    CREATE_OR_UPDATE_STUDY: `${environment.api.baseUri}/Study/CreateOrUpdateStudy`,
    GET_STUDY_DETAILS: `${environment.api.baseUri}/Study/GetStudyDetails`,
    GET_KPIs: `${environment.api.baseUri}/FADashboard/getKPIs_Post`,
    GET_ALL_COMPANY_DETAILS: `${environment.api.baseUri}/Dashboard/GetNexgenSearchAndFilteredPeers`,
    EXPORT_KPIS: `${environment.api.baseUri}/FADashboard/ExportKPIs`,
    GET_TEMPLATE_LIST: `${environment.api.baseUri}/FADashboard/getKPITemplates`,
    GET_COMPANY_DETAILS: `${environment.api.baseUri}/Dashboard/InsertNexgenStudyPeer`,
    GET_STUDY_DETAILS_COMPLETE_INFO: `${environment.api.baseUri}/FADashboard/GetNexgenStudyAllDetailByStudyId`
  },
  APQCADMIN: {
    GET_EXCEL_REPORT: `${environment.api.baseUri}/Dashboard/ExportToExcelReport`
  },
  LOG: {
    LOGACTION: `${environment.api.baseUri}api/audit/LogActions`
  },
  TOKEN_ENDPOINT: `${environment.api.baseUri}/token`,
  ADMIN: {
    GET_DASBOARD_DATA: `${environment.api.baseUri}/Dashboard/GetBMPDashboardConfigDetails`,
    GET_ALL_EMAILS: `${environment.api.baseUri}/Admin/GetAllEmails`,
    GET_EMAIL_BY_ID: `${environment.api.baseUri}/Admin/GetEmailById`,
    RESEND_EMAIL: `${environment.api.baseUri}/Admin/ResendEmail`,
    GET_MANAGEUSER_REPORTLIST: `${environment.api.baseUri}/ManageUsers/GetReportList`,
    GET_MANAGEUSER_GROUPLIST: `${environment.api.baseUri}/ManageUsers/GetGroupListByReportName`,
    GET_MANAGEUSER_USERLIST: `${environment.api.baseUri}/ManageUsers/GetUserListBySecurityGroupId`,
    GET_AUDIT_LOG_DETAILS: `${environment.api.baseUri}/Admin/GetAllAuditLogs`,
    EXPORT_AUDIT_LOG_DETAILS: `${environment.api.baseUri}/Admin/ExportAuditLogs`
  },
  ADMIN_FABRIC: {
    // LIST_WORKSPACES: `https://api.fabric.microsoft.com/v1/workspaces`,
    // GET_ITEMS: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items`,
    // LIST_SCHEDULES: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/{jobType}/schedules`,
    // CREATE_SCHEDULE: `https://localhost:44346/api/AdminFabric`,
    // UPDATE_SCHEDULE: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/{jobType}/schedules/{scheduleId}`,
    // DELETE_SCHEDULE: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/{jobType}/schedules/{scheduleId}`,
    // LIST_INSTANCES: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/instances`,
    // CANCEL_INSTANCE: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/instances/{jobInstanceId}/cancel`,
    // GET_INSTANCE: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/instances/{jobInstanceId}`,
    // RUN_ON_DEMAND: `https://api.fabric.microsoft.com/v1/workspaces/{workspaceId}/items/{itemId}/jobs/instances?jobType={jobType}`
    
    LIST_WORKSPACES: `${environment.api.baseUri}/Admin/Fabric/GetAllWorkspaces`,
    GET_ITEMS: `${environment.api.baseUri}/Admin/Fabric/GetWorkspaceItems`,
    LIST_SCHEDULES: `${environment.api.baseUri}/Admin/Fabric/GetAllItemSchedules`,
    CREATE_SCHEDULE: `${environment.api.baseUri}/Admin/Fabric/CreateNewSchedule`,
    UPDATE_SCHEDULE: `${environment.api.baseUri}/Admin/Fabric/UpdateSchedule`,
    DELETE_SCHEDULE: `${environment.api.baseUri}/Admin/Fabric/DeleteSchedule`,
    LIST_INSTANCES: `${environment.api.baseUri}/Admin/Fabric/GetAllInstances`,
    CANCEL_INSTANCE: `${environment.api.baseUri}/Admin/Fabric/CancelInstance`,
    GET_INSTANCE: `${environment.api.baseUri}/Admin/Fabric/GetInstance`,
    RUN_ON_DEMAND: `${environment.api.baseUri}/Admin/Fabric/RunInstance`
  },
  USER_INFO: `${environment.api.baseUri}api/auth/GetUserFromClaims`,
  KeyVault_Secret: `${environment.api.baseUri}api/auth/GetSecret`
  /*USER_INFO: `${environment.api.baseUri}/Profiles/GetUserDetailsByEmail`*/
};
